 // NATIVE 
  import * as React from 'react';
  
  // INSTALLED 
  import Paper from '@mui/material/Paper';
  import Table from '@mui/material/Table';
  import Button from '@mui/material/Button';
  import Divider from '@mui/material/Divider';
  import MenuItem from '@mui/material/MenuItem';
  import TableRow from '@mui/material/TableRow';
  import EditIcon from '@mui/icons-material/Edit';
  import TableBody from '@mui/material/TableBody';
  import TableHead from '@mui/material/TableHead';
  import DeleteIcon from '@mui/icons-material/Delete';
  import Menu, { MenuProps } from '@mui/material/Menu';
  import { styled, alpha  } from '@mui/material/styles';
  import { useDispatch, useSelector } from 'react-redux';
  import { DialogArea } from '../modals/areas/DialogArea';
  import TableContainer from '@mui/material/TableContainer';
  import VisibilityIcon from '@mui/icons-material/Visibility';
  import TableCell, { tableCellClasses } from '@mui/material/TableCell';
  import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
  import { Box, Card, Chip, Pagination, TablePagination } from '@mui/material';
  
  
  
  
  // CUSTOM 
  import { paddingCardsTables, timeToClosedToast } from '../../commons';
  import { closeSessionGlobal, corregirTexto, firstLetterUpperCase, hasPemissions, usarFuncionesComposicion, validateResponse } from '../../commons/utils';
  import { showNumberRowsTable } from '../../commons/utils/values';
  import { ModalSessionExpired } from '../generics/ModalSessionExpired';
  import { getAreasByPagination } from '../../store/areas';
  import { SnackAlert } from '../SnackAlert';
  import { getTerminalDescansosStore, storeActiveTerminalDescanso,  storeDesactiveTerminalDescanso, storeDetailTerminalDescanso } from '../../store/terminal-descansos/thunks';
  import { DetalleDialogTerminal, EditarDialogTerminal } from '../modals/terminal/terminal-control-tiempo-empleados';
import MultipleSnackbars from '../MultipleSnackbars';
import { DetalleDialogTerminalDescansos, EditarDialogTerminalDescansos } from '../modals/terminal/terminal-descansos';
  
  
  
           
  
  
  
  
  
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: theme.palette.secondary.contrastText,
      fontSize: 15,
      fontWeight: 700
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      fontWeight: 500,
      color: '#2e263de6'
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  
  
  
  

  export const TableEmployeeTerminalDescansos = () => {
  
  
     // DISPATCH
    const dispatch = useDispatch();
  
  
    // REDUX 
    const { terminaldescansos_list }:any  = useSelector( (state:any) => state.terminalDescansos );
  
  
    // USE STATE 
    const [dataTableList, setDataTable] = React.useState([]);
    const [pagination, setPagination] = React.useState<any>({
        "page": 1,
        "take": 1,
        "itemCount": 1,
        "pageCount": 1,
        "hasPreviousPage": false,
        "hasNextPage": false
    });
  
  
    const [openElem, setOpenElem] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  
    
    
    
    const [canEdit, setCanEdit]     = React.useState<boolean>(false);
    const [canDelete, setCanDelete]     = React.useState<boolean>(false);
    const [canRestore, setCanRestore]     = React.useState<boolean>(false);
  
    const [page, setPage] = React.useState(0);
    const [pagePagination, setPagePagination] = React.useState(1);
    const [itemCountPagination, setItemCountPagination] = React.useState(1);
    const [rowsPerPage, setRowsPerPage] = React.useState(showNumberRowsTable);
  
    const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
    const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);
  
    const [open_d, setOpen]     = React.useState(false);
    const [buttons, setButtons] = React.useState(false);
    const [modalDetalle, setModalDetalle] = React.useState(false);
    const [modalEditar, setModalEditar] = React.useState(false);
  
    const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);
  
    const [alert_snack, setAlertSnack] = React.useState(false);
    const [msgSnack, setMsgSnack] = React.useState({
        msg: '',
        status: 'success'
    });
  
    // USE EFFECT 
    React.useEffect(() => {
      
      if ( terminaldescansos_list.data && terminaldescansos_list.data.length > 0 ) {
       
        setDataTable(terminaldescansos_list.data);
        setPagination({
          "page": terminaldescansos_list.meta.page,
          "take": terminaldescansos_list.meta.take,
          "itemCount": terminaldescansos_list.meta.itemCount,
          "pageCount": terminaldescansos_list.meta.pageCount,
          "hasPreviousPage": terminaldescansos_list.meta.hasPreviousPage,
          "hasNextPage": terminaldescansos_list.meta.hasNextPage
        });
        setItemCountPagination(terminaldescansos_list.meta.pageCount);
        
      }
      
  
    }, [terminaldescansos_list]);
  
  
  
     // USE EFFECT 
    React.useEffect( () => {
        // HERE LOAD THE DATA FOR DATATABLE
        getDataTerminalDescansos();
    }, []);
  
  
    React.useEffect(() => {
      checkEdit()
    }, []);
  
    React.useEffect(() => {
        checkCanDelete()
    }, []);
  
    React.useEffect(() => {
      checkRestore()
    }, []);
    
  
  
  
     // CONST STYLES
     const StyledMenu = styled((props: MenuProps) => (
      <Menu
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        {...props}
      />
    ))(({ theme }) => ({
      '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
          theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
          'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
          padding: '7px 0',
        },
        '& .MuiMenuItem-root': {
          '& .MuiSvgIcon-root': {
            fontSize: 18,
            color: theme.palette.text.secondary,
            marginRight: theme.spacing(1.5),
          },
          '&:active': {
            backgroundColor: alpha(
              theme.palette.primary.main,
              theme.palette.action.selectedOpacity,
            ),
          },
        },
      },
    }));
    
  
    const Div = styled('div')(({ theme }) => ({
      ...theme.typography.button,
      backgroundColor: 'wheat',
      padding: theme.spacing(8),
      textAlign: 'center'
    }));
  
  
  
     // CONST VALUE
     const open = Boolean(anchorEl);
  
  
  
     // CONST FUNCTIONS 
  
    const getDataTerminalDescansos = async() => {
    
          const response = await dispatch( getTerminalDescansosStore() );
  

          await validateResponse(response, 'Listar Terminal', {
                                  setMsgSnack,
                                  setAlertSnack,
                                  setModalSessionExpired,
                                });
    
    }
  
  
    const handleClick = (elem:any) => (event:any) => {
      setAnchorEl(event.currentTarget);
      setOpenElem(elem);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
      setOpenElem(null);
    };
  
    
  
  
    const openDialogDetalle = async(terminalId:string) => {
        
          setAnchorEl(null);
          setOpenElem(null);
          setButtons(false);
  
         const response =  await dispatch( storeDetailTerminalDescanso(terminalId) );
  
         
        await validateResponse(response, 'Detalle Terminal', {
                                  setMsgSnack,
                                  setAlertSnack,
                                  setModalSessionExpired,
                                }, false);


  
         if( !response.ok ) {
            return false;
         } 
  
         
         setModalDetalle(response);
    }
  
    const openDialogEditar = async(terminalId:string) => {
        
      setAnchorEl(null);
      setOpenElem(null);
      setButtons(false);
  
      const response = await dispatch( storeDetailTerminalDescanso(terminalId) );
  
     
  
      // const result = await validateResponse(response, ' (Detalle Terminal) ');
      await validateResponse(response, 'Detalle Terminal', {
                                  setMsgSnack,
                                  setAlertSnack,
                                  setModalSessionExpired,
                                }, false);
  
      if( !response.ok ) {
        return false;
      } 
  
  
      
      setModalEditar(true);
    }
  
  
    const desactiveTerminal = async(terminalId:string) => {
  
        setAnchorEl(null);
        setOpenElem(null);
        setButtons(false);
        
        const response = await dispatch( storeDesactiveTerminalDescanso(terminalId) );
  
        
        await validateResponse(response, 'Desactivar Terminal', {
                                  setMsgSnack,
                                  setAlertSnack,
                                  setModalSessionExpired,
                                }, true);
        
  
    }
  
  
    const restoreTerminal = async(terminalId:string) => {
  
  
      setAnchorEl(null);
      setOpenElem(null);
      setButtons(false);
  
      const response = await dispatch( storeActiveTerminalDescanso(terminalId) );
  
      await validateResponse(response, 'Restaurar Terminal', {
                                  setMsgSnack,
                                  setAlertSnack,
                                  setModalSessionExpired,
                                }, true);
  
  
    }
  
    
  
    const handleCloseModalCrear = () => {
          setOpen(false)
    }
  
    const handleCloseModalDetail = () => {
         setModalDetalle(false);
    }
  
    
    const handleCloseModalEditar = () => {
         setModalEditar(false);
    }
  
  
  
    const handleChangePage = (event: unknown, newPage: number) => {
  
      setPage(newPage);
  
    };
  
  
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    
          setRowsPerPage(+event.target.value);
    
          setPage(0);
    
    };
  
  
  
    const changePaginationPage = async(event: React.ChangeEvent<unknown>, value: number) => {
            
            setPagePagination(value)
        
            const response =  await dispatch( getAreasByPagination(value) );
  
            // await validateResponse(response, ' (Listar Areas) ');
            
        
    };
  
   
  
  
  
  
  
    const checkEdit = async() => {
  
        const hasPermissionsEdit = await hasPemissions('modulo.configuracion', 'modulo.terminales', 'edit' );
      
        if ( hasPermissionsEdit ) {
              setCanEdit(true);
        }
    }
  
    const checkCanDelete = async() => {
        
        const hasPermissionsDelete = await hasPemissions('modulo.configuracion', 'modulo.terminales', 'delete' );
        
        if ( hasPermissionsDelete ) {
              setCanDelete(true);
        }
  
    }
  
  
    const checkRestore = async() => {
        
        const hasPermissionsRestore = await hasPemissions('modulo.configuracion', 'modulo.terminales', 'restore' );
          
        if ( hasPermissionsRestore ) {
              setCanRestore(true);
        }
  
    }
  
  
    return (
  
      <>
  
           {/* *****************************************************************
          ******  COMPONENTS PARA MANEJAR MENSAJES DEL RESPONSE  **************
          *********************************************************************/}
          <ModalSessionExpired  open={modalSessionExpired}  />
          <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
          <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
      {/* ******************************************************************
          ******  COMPONENTS PARA MANEJAR MENSAJES DEL RESPONSE  **************
          *********************************************************************/}



  
         <DetalleDialogTerminalDescansos open={modalDetalle} handleCloseModalDetail={handleCloseModalDetail} />
         <EditarDialogTerminalDescansos  open={modalEditar} btnSubmiting={false} handleCloseModalEditar={handleCloseModalEditar} />
  
          {
        
           dataTableList.length > 0
  
             ?
             <>
              <Card
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  p: 3,
                  borderRadius: 2,
                  boxShadow: 3,
                  bgcolor: 'background.paper',
                  marginTop: paddingCardsTables
                }}
              >
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Nombre</StyledTableCell>
                        <StyledTableCell>Descripcion</StyledTableCell>
                        <StyledTableCell>Codigo</StyledTableCell>
                        <StyledTableCell>Tipo Terminal</StyledTableCell>
                        <StyledTableCell>Estado</StyledTableCell>
                        <StyledTableCell>Acciones</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                      dataTableList
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row:any, index:any) => (
                        <StyledTableRow key={index+1}>
                          <StyledTableCell component="th" scope="row">
                            {usarFuncionesComposicion(corregirTexto, firstLetterUpperCase, row.name)}
                          </StyledTableCell>
                          <StyledTableCell >
                            {usarFuncionesComposicion(corregirTexto, firstLetterUpperCase, row.description)}
                          </StyledTableCell>
                          <StyledTableCell >
                            {row.code}
                          </StyledTableCell>
                          <StyledTableCell >
                            {usarFuncionesComposicion(corregirTexto, firstLetterUpperCase, row.typeTerminal)}
                          </StyledTableCell>
                          <StyledTableCell >
                            {
                              row.status ? <Chip size='small' label="Activo" sx={{ color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700 }} /> : <Chip size='small' label="Inactivo" sx={{ color: '#FF4C51', background: '#FFE2E3', fontWeight: 700 }} />
                            }
                          </StyledTableCell>
                          <StyledTableCell  >
                                
                          
                          {
                          
                              <div> 
                                  <Button
                                    id={`demo-customized-button-${index+1}`}
                                    aria-controls={open ? `demo-customized-menu-${index+1}` : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    variant="text"
                                    disableElevation
                                    onClick={handleClick(row)}
                                    endIcon={<KeyboardArrowDownIcon />}
                                  >
                                    Acciones
                                  </Button>
                                  <StyledMenu
                                    id={`demo-customized-menu-${index+1}`}
                                    MenuListProps={{
                                      'aria-labelledby': `demo-customized-button-${index+1}`,
                                    }}
                                    anchorEl={anchorEl}
                                    open={openElem === row}
                                    onClose={handleClose}
                                  >
                                    
                                    {
                                      (row.status) 
                                        ? <div>
                                          <MenuItem onClick={ () => openDialogDetalle(row.id) }  disableRipple>
                                                        <VisibilityIcon />
                                                          Detalle 
                                                        </MenuItem>
                                          
                                          
                                          <Divider sx={{ my: 0.5 }} />
                                          {
                                            canEdit && <MenuItem onClick={ () => openDialogEditar(row.id) }  disableRipple>
                                                        <EditIcon />
                                                          Editar
                                                      </MenuItem>
                                          }
                                        </div>
                                        :
                                        ''
                                    }
                                    
                                    {
                                      (row.status) 
                                      ?
                                        <div>
                                          {
                                            canDelete && <>
                                                          <Divider sx={{ my: 0.5 }} />
                                                          <MenuItem onClick={ () => desactiveTerminal(row.id) } disableRipple>
                                                            <DeleteIcon />
                                                            Desactivar
                                                          </MenuItem>
                                                        </>
                                          }
                                          
                                        </div>
                                      :
                                      <div>
                                         {
                                            canRestore &&  <>
                                                            <Divider sx={{ my: 0.5 }} />
                                                            <MenuItem onClick={ () => restoreTerminal(row.id) } disableRipple>
                                                              <DeleteIcon />
                                                              Activar
                                                            </MenuItem>
                                                          </>
                                         }
                                      </div>
                                      
                                    }
                                    </StyledMenu>
                                </div>
                      
                          }
          
          
          
          
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
              <TablePagination
              rowsPerPageOptions={[5, 10]}
              labelRowsPerPage={'Filas por pagina'}
              labelDisplayedRows={({ from, to, count }) => ` ${from}-${to} de  ${count} `}
              component="div"
              count={pagination.itemCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={ handleChangePage }
              onRowsPerPageChange={ handleChangeRowsPerPage }
            />
  
            <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 2,
                    marginBottom: 2
                  }}
                >
                <Pagination sx={{ justifyContent: 'center' }} color="primary" count={itemCountPagination} page={pagePagination} onChange={ changePaginationPage} showFirstButton showLastButton />
            </Box>
            </>
             :
             <Div>{"No hay terminales disponibles..."}</Div>
         }
         
  
         
      </>
      
    );
  }
  
  
  